import { takeLatest } from 'redux-saga/effects';
import { signOut } from "services/AuthService";

export const SAGA_SIGN_OUT = 'SAGA_SIGN_OUT';

export function signOutAction() {
  return { type: SAGA_SIGN_OUT };
}

export function* watchForSignOut() {
  yield takeLatest(SAGA_SIGN_OUT, signOut)
}
